import { getLogger } from '@confluence/logger';

const logger = getLogger('retrieveContentExtensionsCount');

export type ContentExtensionsCount = {
	connectExtensions: Record<string, number>;
	forgeExtensions: Record<string, number>;
};

type Node = {
	type?: any;
	attrs?: {
		extensionType?: string;
	};
};

export const retrieveContentExtensionsCount = (contentBody: string) => {
	try {
		const contentExtensionsCount: ContentExtensionsCount = {
			connectExtensions: {},
			forgeExtensions: {},
		};
		const document = JSON.parse(contentBody);
		document?.content?.forEach((node: Node) =>
			retrieveContentExtensionsCountFromNode(node, contentExtensionsCount),
		);
		return contentExtensionsCount;
	} catch {
		logger.error`Unable to parse ADF`;
		return {};
	}
};

export function retrieveContentExtensionsCountFromNode(
	{ attrs, type }: Node,
	contentExtensionsCount: ContentExtensionsCount,
) {
	if (attrs && type) {
		const { extensionType } = attrs;

		// Forge extensions have extensionType of 'com.atlassian.ecosystem' whereas Connect extensions have 'com.atlassian.confluence.macro.core'.
		let extensionsObj: undefined | ContentExtensionsCount[keyof ContentExtensionsCount];
		if (extensionType === 'com.atlassian.ecosystem') {
			extensionsObj = contentExtensionsCount.forgeExtensions;
		} else if (extensionType === 'com.atlassian.confluence.macro.core') {
			extensionsObj = contentExtensionsCount.connectExtensions;
		} else {
			return;
		}

		if (extensionsObj) {
			extensionsObj[type] = (extensionsObj[type] || 0) + 1;
		}
	}
}
